import { render } from "./ScoreBriefInfoMobile.vue?vue&type=template&id=042be51a&scoped=true"
import script from "./ScoreBriefInfoMobile.vue?vue&type=script&lang=js"
export * from "./ScoreBriefInfoMobile.vue?vue&type=script&lang=js"

import "./ScoreBriefInfoMobile.vue?vue&type=style&index=0&id=042be51a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042be51a"]])

export default __exports__